module.exports = __webpack_public_path__ + "img/concentration.bbb2adb2.svg";